/* istanbul ignore file */
import React from 'react';
import { SecurityContextTemplate } from 'framework/authorization';
import useContactService from 'domain/sales/contact/shared/contactService';

const CONTACT_CONTEXT = 'Contact';

const ContactContext = ({
  permissionToCheck,
  children,
}: {
  permissionToCheck: string | string[];
  children: React.ReactNode;
}) => {
  const { getPermissions } = useContactService();

  return (
    <SecurityContextTemplate
      getPermissionsFunc={getPermissions}
      permissionToCheck={permissionToCheck}
      contextName={CONTACT_CONTEXT}
    >
      {children}
    </SecurityContextTemplate>
  );
};

export default ContactContext;
